/*
 * Marketing API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.26
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The InlineResponse2008Data model module.
 * @module model/InlineResponse2008Data
 * @version 1.0.0
 */
export class InlineResponse2008Data {
  /**
   * Constructs a new <code>InlineResponse2008Data</code>.
   * @alias module:model/InlineResponse2008Data
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>InlineResponse2008Data</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/InlineResponse2008Data} obj Optional instance to populate.
   * @return {module:model/InlineResponse2008Data} The populated <code>InlineResponse2008Data</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new InlineResponse2008Data();
      if (data.hasOwnProperty('result'))
        obj.result = ApiClient.convertToType(data['result'], 'Boolean');
    }
    return obj;
  }
}

/**
 * @member {Boolean} result
 */
InlineResponse2008Data.prototype.result = undefined;

